import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetCapacityPlanDeliveryCoordinatesMutationVariables = Types.Exact<{
  input: Types.SetCapacityPlanDeliveryCoordinatesInput;
}>;


export type SetCapacityPlanDeliveryCoordinatesMutation = { __typename?: 'Mutation', setCapacityPlanDeliveryCoordinates: { __typename?: 'SetCapacityPlanDeliveryCoordinatesPayload', capacityPlanDeliveryCoordinatesPayload?: { __typename?: 'CapacityPlanDeliveryCoordinatesPayload', runId: any, deliveryId: any, geocodeStatus: Types.CapacityPlanGeocodeStatus, latitude: number, longitude: number } | null, errors?: Array<{ __typename?: 'CapacityPlanUserError', code: Types.CapacityPlanErrorCode, message: string, runId?: any | null, deliveryId?: any | null }> | null } };


export const SetCapacityPlanDeliveryCoordinatesDocument = gql`
    mutation SetCapacityPlanDeliveryCoordinates($input: SetCapacityPlanDeliveryCoordinatesInput!) {
  setCapacityPlanDeliveryCoordinates(input: $input) {
    capacityPlanDeliveryCoordinatesPayload {
      runId
      deliveryId
      geocodeStatus
      latitude
      longitude
    }
    errors {
      ... on CapacityPlanUserError {
        code
        message
        runId
        deliveryId
      }
    }
  }
}
    `;
export type SetCapacityPlanDeliveryCoordinatesMutationFn = Apollo.MutationFunction<SetCapacityPlanDeliveryCoordinatesMutation, SetCapacityPlanDeliveryCoordinatesMutationVariables>;

/**
 * __useSetCapacityPlanDeliveryCoordinatesMutation__
 *
 * To run a mutation, you first call `useSetCapacityPlanDeliveryCoordinatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCapacityPlanDeliveryCoordinatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCapacityPlanDeliveryCoordinatesMutation, { data, loading, error }] = useSetCapacityPlanDeliveryCoordinatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCapacityPlanDeliveryCoordinatesMutation(baseOptions?: Apollo.MutationHookOptions<SetCapacityPlanDeliveryCoordinatesMutation, SetCapacityPlanDeliveryCoordinatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCapacityPlanDeliveryCoordinatesMutation, SetCapacityPlanDeliveryCoordinatesMutationVariables>(SetCapacityPlanDeliveryCoordinatesDocument, options);
      }
export type SetCapacityPlanDeliveryCoordinatesMutationHookResult = ReturnType<typeof useSetCapacityPlanDeliveryCoordinatesMutation>;
export type SetCapacityPlanDeliveryCoordinatesMutationResult = Apollo.MutationResult<SetCapacityPlanDeliveryCoordinatesMutation>;
export type SetCapacityPlanDeliveryCoordinatesMutationOptions = Apollo.BaseMutationOptions<SetCapacityPlanDeliveryCoordinatesMutation, SetCapacityPlanDeliveryCoordinatesMutationVariables>;